<template>
  <v-container fluid>
    <v-tabs>
      <v-tab>
        Admin Users
      </v-tab>
      <v-tab>
        Portal Users
      </v-tab>
      <v-tab-item>
        <users-table-component />
      </v-tab-item>
      <v-tab-item>
        <users-table-component
          :is-portal-user-table="true"
        />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import UsersTableComponent from './UsersTableComponent.vue';

export default {
  name: 'Users',
  components: {
    UsersTableComponent,
  },
};
</script>
